/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PutApiV1TutoraiConfigMemoryMutationRequest,
  PutApiV1TutoraiConfigMemoryMutationResponse,
  PutApiV1TutoraiConfigMemory400,
  PutApiV1TutoraiConfigMemory401,
  PutApiV1TutoraiConfigMemory500,
} from "../../types/tutorAIConfigController/PutApiV1TutoraiConfigMemory.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { putApiV1TutoraiConfigMemory } from "../../clients/tutorAIConfigController/putApiV1TutoraiConfigMemory.ts";

export const putApiV1TutoraiConfigMemoryMutationKey = () =>
  [{ url: "/api/v1/tutorai/config/memory" }] as const;

export type PutApiV1TutoraiConfigMemoryMutationKey = ReturnType<
  typeof putApiV1TutoraiConfigMemoryMutationKey
>;

export function putApiV1TutoraiConfigMemoryMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PutApiV1TutoraiConfigMemoryMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = putApiV1TutoraiConfigMemoryMutationKey();
  return mutationOptions<
    PutApiV1TutoraiConfigMemoryMutationResponse,
    ResponseErrorConfig<
      | PutApiV1TutoraiConfigMemory400
      | PutApiV1TutoraiConfigMemory401
      | PutApiV1TutoraiConfigMemory500
    >,
    { data?: PutApiV1TutoraiConfigMemoryMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return putApiV1TutoraiConfigMemory(data, config);
    },
  });
}

/**
 * @description Salva a memória no TutorAI. `isGlobal=true` → global. `classStudentId` sem `personId` → memória da turma. `classStudentId` + `personId` → memória específica do aluno (requer classStudentId). **(Requer Authorization para autenticação)**
 * @summary Atualizar memória do assistente (Requer Authorization para autenticação)
 * {@link /api/v1/tutorai/config/memory}
 */
export function usePutApiV1TutoraiConfigMemory<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiV1TutoraiConfigMemoryMutationResponse,
      ResponseErrorConfig<
        | PutApiV1TutoraiConfigMemory400
        | PutApiV1TutoraiConfigMemory401
        | PutApiV1TutoraiConfigMemory500
      >,
      { data?: PutApiV1TutoraiConfigMemoryMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PutApiV1TutoraiConfigMemoryMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? putApiV1TutoraiConfigMemoryMutationKey();

  const baseOptions = putApiV1TutoraiConfigMemoryMutationOptions(
    config,
  ) as UseMutationOptions<
    PutApiV1TutoraiConfigMemoryMutationResponse,
    ResponseErrorConfig<
      | PutApiV1TutoraiConfigMemory400
      | PutApiV1TutoraiConfigMemory401
      | PutApiV1TutoraiConfigMemory500
    >,
    { data?: PutApiV1TutoraiConfigMemoryMutationRequest },
    TContext
  >;

  return useMutation<
    PutApiV1TutoraiConfigMemoryMutationResponse,
    ResponseErrorConfig<
      | PutApiV1TutoraiConfigMemory400
      | PutApiV1TutoraiConfigMemory401
      | PutApiV1TutoraiConfigMemory500
    >,
    { data?: PutApiV1TutoraiConfigMemoryMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PutApiV1TutoraiConfigMemoryMutationResponse,
    ResponseErrorConfig<
      | PutApiV1TutoraiConfigMemory400
      | PutApiV1TutoraiConfigMemory401
      | PutApiV1TutoraiConfigMemory500
    >,
    { data?: PutApiV1TutoraiConfigMemoryMutationRequest },
    TContext
  >;
}
